// src/firebase.js
import { initializeApp } from "firebase/app";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
// import { getAnalytics } from "firebase/analytics";
// Import other Firebase services you plan to use (e.g., Auth, Firestore)
// import { getAuth } from 'firebase/auth';
// import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAZbwsLrYrA3WVPzFKQDrloUzUwvIOgd1c",
  authDomain: "zfd-notary-services.firebaseapp.com",
  projectId: "zfd-notary-services",
  storageBucket: "zfd-notary-services.firebasestorage.app",
  messagingSenderId: "778171909494",
  appId: "1:778171909494:web:73e43876f234c245eee657",
  measurementId: "G-QJ1877XN0V",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
// const analytics = getAnalytics(app);

// Export services if needed
// export const auth = getAuth(app);

if (window.location.hostname === "localhost") {
  connectFirestoreEmulator(db, "localhost", 8080);
}

export { db };

export default app;
